import { IconButton, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import dayjs from 'dayjs';
import { InboxChat } from 'types/user';
import { capitalizeFirstLetter } from 'utils/index';
import DeleteIcon from '@mui/icons-material/Delete';
import { renderWithLinks } from './ChatBox';

type Props = {
  notes: InboxChat[];
  onDeleteDetail: (idChat: number) => void;
};

export const FileInboxNotesTableCb = ({ notes, onDeleteDetail }: Props) => {
  return (
    <Table
      size="small"
      sx={{
        '.MuiTableCell-root': {
          padding: '16px'
        }
      }}>
      <TableHead>
        <TableRow>
          <TableCell sx={{ minWidth: '120px' }}>Updated By</TableCell>
          <TableCell sx={{ minWidth: '160px' }}>Date</TableCell>
          <TableCell sx={{ minWidth: '160px' }}>Subject</TableCell>
          <TableCell sx={{ minWidth: '200px' }}>Details</TableCell>
          <TableCell width={120}>Action</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {notes.map((note) => (
          <TableRow key={note.id}>
            <TableCell>
              {note?.user?.role === 'ROOT_ADMIN'
                ? 'Master Admin'
                : note?.user?.firstName || note?.user?.lastName
                  ? `${note?.user?.firstName || ''} ${note?.user?.lastName || ''}`.trim()
                  : 'Admin'}
            </TableCell>

            <TableCell>{dayjs(note?.createdAt).format('YYYY/MM/DD HH:mm A')}</TableCell>

            <TableCell>{capitalizeFirstLetter(note.subject || 'INCOMING_MESSAGE')}</TableCell>

            <TableCell>{renderWithLinks(note.content)}</TableCell>
            <TableCell>
              <IconButton
                onClick={() => {
                  onDeleteDetail(note.id);
                }}>
                <DeleteIcon />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
